// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.recommend-list[data-v-d2aa2bd0] {\r\n  border-radius: 5px;\r\n  background: #fff;\r\n  padding: 20px;\n}\n.recommend-list .title[data-v-d2aa2bd0] {\r\n  font-weight: normal;\r\n  font-size: 16px;\r\n  margin-bottom: 10px;\n}\n.recommend-list .title a[data-v-d2aa2bd0] {\r\n  color: #000;\n}\n.recommend-list .title a[data-v-d2aa2bd0]:hover {\r\n  color: #44B549;\n}\n.recommend-list .image[data-v-d2aa2bd0] {\r\n  width: 260px;\r\n  height: 155px;\r\n  border-radius: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
